// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1J2eD","footer":"ReportModalFilter_footer__1Hl4Z"};